import { selectDraft, selectInternalUsers } from '@/store/selectors/createSix';
import { setDraftField } from '@/store/slices/createSix/createSixSlice';
import { usePersonPicker } from '@/hooks/shared/usePersonPicker';

export function useStepInternalParticipants() {
  const { state, handlers } = usePersonPicker({
    selectDraft,
    selectUsers: selectInternalUsers,
    dispatchSetField: (dispatch, key, value) => dispatch(setDraftField({ key, value })),
    primaryKey: 'internalParticipantIds',
    exclusionKey: 'ownerIds',
  });

  return {
    state: {
      selectedMembers: state.selected,
      candidateMembers: state.candidates,
      searchValue: state.searchValue,
    },
    handlers: {
      handleSearchValueChange: handlers.handleSearchChange,
      handleRemoveMember: handlers.handleRemove,
      handleAddMember: handlers.handleAdd,
    },
  };
}
